// extracted by mini-css-extract-plugin
export default {"progress_dot":"progress-bar_progress_dot__F-JOl"};